import React from 'react';
import { KTCard } from '../../../../_metronic/helpers/components/KTCard';
import { KTCardBody } from '../../../../_metronic/helpers/components/KTCardBody';

interface Props {
    dateInformationRef: any
    orderDate: string | undefined
    setOrderDate: React.Dispatch<React.SetStateAction<string | undefined>>
    loadingDate: string | undefined
    setLoadingDate: React.Dispatch<React.SetStateAction<string | undefined>>
    deliverDate: string | undefined
    setDeliverDate: React.Dispatch<React.SetStateAction<string | undefined>>
    estDeliverDate: string | undefined
    setEstDeliverDate: React.Dispatch<React.SetStateAction<string | undefined>>
}

const DateInformation = ({
    dateInformationRef,
    orderDate,
    setOrderDate,
    loadingDate,
    setLoadingDate,
    deliverDate,
    setDeliverDate,
    estDeliverDate,
    setEstDeliverDate
}: Props) => {
    return (
        <div className='containerPart' ref={dateInformationRef}>
            <KTCard className="ebbe-card mt-10">
                <KTCardBody>
                    <h4 className="mb-10 text-black">Tarih Bilgileri</h4>

                    <div className={'row'}>
                        <div className="col-md-4">
                            <div>
                                <label htmlFor="exampleFormControlInput1" className="form-label required">Sipariş Tarihi</label>

                                <input style={{ border: '1px solid #F1F1F4' }} value={orderDate} onChange={(e) => setOrderDate(e.target.value)} type="date" className="form-control form-control-solid" />
                            </div>

                            <div className="mt-5">
                                <label htmlFor="exampleFormControlInput1" className="form-label">Tahmini Teslim Tarihi</label>

                                <input style={{ border: '1px solid #F1F1F4' }} value={estDeliverDate} onChange={(e) => setEstDeliverDate(e.target.value)} type="date" className="form-control form-control-solid" />
                            </div>
                        </div>

                        <div className="col-md-4">
                            <div>
                                <label htmlFor="exampleFormControlInput1" className="form-label">Yükleme Tarihi</label>

                                <input style={{ border: '1px solid #F1F1F4' }} value={loadingDate} onChange={(e) => setLoadingDate(e.target.value)} type="date" className="form-control form-control-solid" />
                            </div>
                        </div>

                        <div className="col-md-4">
                            <label htmlFor="exampleFormControlInput1" className="form-label">Teslim Tarihi</label>

                            <input style={{ border: '1px solid #F1F1F4' }} value={deliverDate} onChange={(e) => setDeliverDate(e.target.value)} type="date" className="form-control form-control-solid" />
                        </div>
                    </div>
                </KTCardBody>
            </KTCard>
        </div>
    )
}

export default DateInformation;